import {
    Zone
  } from '../../../../../core';

  export const listNewRoute = {
    columns:[
      {
        title: 'Ruta/s',
        name: 'route',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => element.route
      },
    ]
  }

  export const integrationRoute = {
    searchText: 'Buscar zonas no asignadas',
    addText: '',
    export: false,
    filter: false,
    filterDefault: '',
    checkbox: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Nombre',
        name: 'name',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.name
      },
      {
        title: 'Departamento/Provincia',
        name: 'departmentName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.departmentName
      },
      {
        title: 'Provincia/Cantones',
        name: 'provinceName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => element.provinceName
      },
      {
        title: 'Estado',
        name: 'status',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Zone) => {
          if (element.status === 'UNCONFIGURED_ROUTE') {
            return 'Sin ruta(s) de despacho';
          } else {
            return 'Posee ruta(s) de despacho';
          }
        }
      }
    ]
  };
